import type { ComputedRef, InjectionKey, WritableComputedRef } from 'vue'

export interface BPaginationContext {
  currentPage?: WritableComputedRef<number>
  pageCount?: ComputedRef<number>
  disabled?: ComputedRef<boolean>
  changeEvent?: (val: number) => void
  handleSizeChange?: (val: number) => void
}

export const bPaginationKey: InjectionKey<BPaginationContext> =
  Symbol('bPaginationKey')
